import { render, staticRenderFns } from "./ClaimDeviceScreen.vue?vue&type=template&id=6a8f2621&"
import script from "./ClaimDeviceScreen.vue?vue&type=script&lang=js&"
export * from "./ClaimDeviceScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports